import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// Un même message d'erreur n'est affiché qu'une fois: l'intercepteur de
// `lib/api.js` toaste déjà l'échec, et la page qui l'a provoqué le toaste
// souvent à son tour. Avec un identifiant égal au texte, le second remplace le
// premier au lieu de s'empiler.
if (!toast.error.__dedoublonne) {
  const erreurBrute = toast.error.bind(toast)
  const erreur = (message, options) =>
    erreurBrute(message, typeof message === "string" ? { id: message, ...options } : options)
  erreur.__dedoublonne = true
  toast.error = erreur
}

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
